export const isAbsoluteUrl = new RegExp('^(?:[a-z]+:)?//', 'i') //eslint-disable-line
